/**
 * Date format constants and options for user preferences
 */

export interface IDateFormatOption {
  value: string
  label: string
  preview: string
  description: string
}

/**
 * Predefined date format options for user selection
 * Format values are moment.js format strings
 */
export const DATE_FORMAT_OPTIONS: IDateFormatOption[] = [
  {
    value: 'LL',
    label: 'Long Date',
    preview: 'January 1, 2024',
    description: 'Full month name, day, and year',
  },
  {
    value: 'MMM DD, YYYY',
    label: 'Medium Date',
    preview: 'Jan 01, 2024',
    description: 'Abbreviated month, day, and year',
  },
  {
    value: 'DD/MM/YYYY',
    label: 'DD/MM/YYYY',
    preview: '01/01/2024',
    description: 'Day/Month/Year (European format)',
  },
  {
    value: 'MM/DD/YYYY',
    label: 'MM/DD/YYYY',
    preview: '01/01/2024',
    description: 'Month/Day/Year (US format)',
  },
  {
    value: 'YYYY-MM-DD',
    label: 'YYYY-MM-DD',
    preview: '2024-01-01',
    description: 'ISO format (Year-Month-Day)',
  },
  {
    value: 'DD MMM YYYY',
    label: 'DD MMM YYYY',
    preview: '01 Jan 2024',
    description: 'Day, abbreviated month, and year',
  },
  {
    value: 'MMMM DD, YYYY',
    label: 'Full Date',
    preview: 'January 01, 2024',
    description: 'Full month name with day and year',
  },
  {
    value: 'LLL',
    label: 'Long Date & Time',
    preview: 'January 1, 2024 12:00 PM',
    description: 'Full date with 12-hour time',
  },
  {
    value: 'MMM DD, YYYY [at] h:mm A',
    label: 'Medium Date & Time',
    preview: 'Jan 01, 2024 at 12:00 PM',
    description: 'Abbreviated date with 12-hour time',
  },
  {
    value: 'DD/MM/YYYY HH:mm',
    label: 'DD/MM/YYYY HH:mm',
    preview: '01/01/2024 14:30',
    description: 'European format with 24-hour time',
  },
  {
    value: 'MM/DD/YYYY h:mm A',
    label: 'MM/DD/YYYY h:mm A',
    preview: '01/01/2024 2:30 PM',
    description: 'US format with 12-hour time',
  },
  {
    value: 'YYYY-MM-DD HH:mm:ss',
    label: 'YYYY-MM-DD HH:mm:ss',
    preview: '2024-01-01 14:30:00',
    description: 'ISO format with 24-hour time',
  },
]

/**
 * Default date format (fallback)
 */
export const DEFAULT_DATE_FORMAT = 'DD MMM YYYY'

/**
 * Time format appended when a timestamp must show time but the preferred date format has none
 */
export const DEFAULT_TIME_FORMAT = 'h:mm A'

/**
 * User preference keys for date formats
 */
export const DATE_FORMAT_PREFERENCE_KEY = 'date-format'
